import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { useMutation } from "@apollo/client";
import { GENERIC_ERROR_MESSAGE, GQL_ERROR } from "../../../constants";

/* Actions */
import { updateToNextStep } from "../../../state/actions";

/* GQL */
import { GET_APP_INFO_AND_ACCOUNTS } from "../../../api/gql/queries";
import { UPDATE_LINK_BANK_STEP } from "./gql";
import { useApplicationState } from "../../../state/store/customHooks";
import withQuery from "../wrappers/gql/withQuery";

import Sentry from "../../../api/sentry";

/* Components */
import LinkBankHeader from "./LinkBankHeader";
import LinkBankForm from "./LinkBankForm";
import { PartnerBanner } from "../../linkbank/components";
import LinkBankFooterV2 from "./LinkBankFooterV2";
import LinkBankAccounts from "./LinkBankAccounts";
import ContinueButton from "../common/ContinueButton";

const LinkBankV2 = ({
  data: linkBankInfo,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getBankAccounts } = linkBankInfo;

  const { status: withQueryGqlStatus, accountsByLogin: totalAccounts } = getBankAccounts;
  const accountsByLogin = totalAccounts || [];
  const existingAccounts = accountsByLogin.length > 0;

  const [updateStep, { loading: updateStepLoading }] = useMutation(UPDATE_LINK_BANK_STEP);

  const currentStep = useApplicationState("currentStep");
  const onboardingStepsOrder = useApplicationState("stepOrder");
  const linkBankStepIndex = onboardingStepsOrder.findIndex((step) => step === onboardingStepsOrder.LINK_BANK);
  const previousSteps = onboardingStepsOrder.slice(0, linkBankStepIndex);
  const stepIncomplete = !previousSteps.includes(currentStep);

  const getBankAccountsError = withQueryGqlStatus === GQL_ERROR ? GENERIC_ERROR_MESSAGE : null;
  const [errorNetwork, setErrorNetwork] = useState(getBankAccountsError);

  const _completeStep = useCallback(async () => {
    let data;
    try {
      data = await updateStep();
    } catch (err) {
      Sentry.captureException(err);
      setErrorNetwork(GENERIC_ERROR_MESSAGE);
      return;
    }

    const { updateLinkBankStep } = data.data;
    const { status } = updateLinkBankStep;

    if(status === GQL_ERROR){
      setErrorNetwork(GENERIC_ERROR_MESSAGE);
      return;
    }

    setErrorNetwork(null);
    dispatch(updateToNextStep(history));

  }, [dispatch, history, updateStep]);

  return (
    <>
      <div className="outerStack-mobile sm:outerStack">
        <div className="innerStack">
          <LinkBankHeader
            stepIncomplete={stepIncomplete}
            accountsByLogin={accountsByLogin}
            existingAccounts={existingAccounts}
          />
          { errorNetwork && <div className="errorText">{errorNetwork}</div>}
          <LinkBankAccounts setErrorNetwork={setErrorNetwork} />
          <div className="flex items-center justify-center">
            <LinkBankForm setErrorNetwork={setErrorNetwork} />
          </div>
          <PartnerBanner isLockLogoVisible />
          { existingAccounts ?
            <ContinueButton
              onClick={_completeStep}
              loading={updateStepLoading}
            /> :
            null
          }
        </div>
      </div>
      <LinkBankFooterV2 />
    </>
  );
};

export default withQuery(GET_APP_INFO_AND_ACCOUNTS)(LinkBankV2);
